<template>
  <component
    :is="resolvedComponent"
    v-model="modelValue"
    v-bind="$attrs"
    :label="label"
    :variant="variant"
    :rules="rules"
    :items="items"
    :item-title="itemTitle"
    :item-value="itemValue"
    :class="fieldClass"
  >
    <template v-if="$slots.label" v-slot:label>
      <slot name="label"></slot>
    </template>
  </component>
</template>

<script setup>
import { computed } from 'vue'
import { VTextField, VSelect, VAutocomplete, VTextarea } from 'vuetify/components'
import { VDateInput, VNumberInput } from 'vuetify/labs/components'   

const props = defineProps({
  modelValue: {
    type: [String, Number, Array, Object],
    default: ''
  },
  fieldType: {
    type: [String, Object],
    default: 'v-text-field'
  },
//   fieldType: {
//     type: String,
//     default: 'v-text-field',
//     validator: (value) => [
//       'v-text-field',
//       'v-autocomplete',
//       'v-select',
//       'v-textarea',
//       'v-number-input',
//       'v-date-input'
//     ].includes(value)
//   },
  label: {
    type: String,
    default: ''
  },
  variant: {
    type: String,
    default: 'outlined'
  },
  rules: {
    type: Array,
    default: () => []
  },
  items: {
    type: Array,
    default: () => []
  },
  itemTitle: {
    type: String,
    default: 'name'
  },
  itemValue: {
    type: String,
    default: 'id'
  },
  fieldClass: {
    type: String,
    default: ''
  },
})

const fieldMap = {
  'v-text-field': VTextField,
  'v-select': VSelect,
  'v-autocomplete': VAutocomplete,
  'v-textarea': VTextarea,
  'v-number-input': VNumberInput,
  'v-date-input': VDateInput,
}

const resolvedComponent = computed(() => fieldMap[props.fieldType] || VTextField)

const emit = defineEmits(['update:modelValue'])

const modelValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})
</script>

<style scoped>
.form-field {
  contain: content;
}
</style> 